module.exports = __webpack_public_path__ + "static/media/success.a0ff09a9.svg";